import styled from '@emotion/styled'
import * as React from 'react'

import { Space } from '../..'

export type TabContentProps = {
  children: React.ReactNode
}

const StyledTabContent = styled(Space)`
  background: var(--White98);
`

export const TabContent = ({ children }: TabContentProps) => (
  <StyledTabContent>{children}</StyledTabContent>
)
